<script setup>
</script>
<template>
  <div class="tw-flex tw-items-center tw-gap-2 tw-px-6 tw-border-neutral tw-border tw-text-neutral-900 tw-text-base tw-flex-grow tw-rounded-lg tw-py-3">
    <svg-vue
      icon="icons/datepicker"
      class="tw-h-4 tw-w-4 tw-text-grey-light"
    />
    <input
      type="text"
      placeholder="--/--/----"
      readonly
      role="button"
      v-bind="$attrs"
    >
  </div>
</template>
